import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { useProps } from "@coveord/plasma-mantine";
import { TimePicker } from "@mantine/dates";
import { useCallback, useState } from "react";
import { TimePickerUtils } from "./TimePickerInputUtils.js";
var defaultProps = {
    value: {
        hour: 10,
        minute: 0
    },
    withSeconds: false
};
export var TimePickerInput = function(_props) {
    var props = useProps("TimePickerInput", defaultProps, _props);
    var formatValue = TimePickerUtils.formatHourMinuteToString(props.value);
    var ref = _sliced_to_array(useState(formatValue), 2), value = ref[0], setValue = ref[1];
    var handleChange = useCallback(function(newValue) {
        var ref;
        setValue(newValue);
        props === null || props === void 0 ? void 0 : (ref = props.onChange) === null || ref === void 0 ? void 0 : ref.call(props, TimePickerUtils.formatStringToHourMinute(newValue));
    }, [
        props
    ]);
    return /*#__PURE__*/ _jsx(TimePicker, _object_spread_props(_object_spread({}, props), {
        value: value,
        onChange: handleChange
    }));
};

//# sourceMappingURL=TimePickerInput.js.map